import { useTranslation } from '@thoughtspot/i18n';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useEffect } from 'react';
import { useResetGitConfigWithOrg } from "../../../services/version-control/version-control";
import { ModalActions, TranslationKeys } from '../constant';
export const ResetConfiguration = ({ isResetModalOpen = false, onResetModalClose, currentOrgId, }) => {
    const { t } = useTranslation();
    const { data: resetConfigData, error, loading: resetConfigLoading, resetConfigWithOrg, } = useResetGitConfigWithOrg();
    const performReset = () => {
        resetConfigWithOrg(currentOrgId);
    };
    const cancelReset = () => {
        onResetModalClose(ModalActions.CANCEL);
    };
    useEffect(() => {
        if (resetConfigData && !resetConfigLoading) {
            onResetModalClose(ModalActions.CONFIRM);
        }
    }, [resetConfigData, resetConfigLoading]);
    return (React.createElement(Modal, { isOpen: isResetModalOpen, size: ModalSize.SMALL, title: t(TranslationKeys.VCS_ADMIN_RIGHT_PANEL_RESET_CONFIGURATION_LABEL), confirmButton: {
            text: t('NO'),
            onConfirm: cancelReset,
        }, dismissButton: {
            text: t('YES'),
            onClick: performReset,
        }, isContentLoading: resetConfigLoading },
        React.createElement(Typography, { variant: "p-large", noMargin: true }, t(TranslationKeys.VCS_ADMIN_RIGHT_PANEL_RESET_CONFIGURATION_MODAL_TEXT))));
};
//# sourceMappingURL=reset-configuration.js.map